export type ChipTone = "ok" | "bad" | "warn" | "info" | "mute";
export function Chip({ tone = "mute", children }: { tone?: ChipTone; children: React.ReactNode }) {
  return <span className={`chip ${tone}`}>{children}</span>;
}
/** Rule: "—", never "0", where data is unavailable (a zero reads as "all good"). */
export function Value({ v, suffix = "" }: { v: number | string | null | undefined; suffix?: string }) {
  if (v === null || v === undefined) return <>—</>;
  return (
    <>
      {typeof v === "number" ? v.toLocaleString("en-IN") : v}
      {suffix}
    </>
  );
}
